(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || window.pawreveEventsBound) return;
  window.pawreveEventsBound = true;
  const root = document.documentElement;
  const ga4Id = root.dataset.pawreveGa4;
  const pixelId = root.dataset.pawreveMetaPixel;
  const qa = new URLSearchParams(window.location.search).get('pawreve_qa') === '1';
  const currency = () => (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function trackGa4(name, params) {
    if (!ga4Id || typeof gtag !== 'function' || root.dataset.pawreveEcommerceOwner === 'google-youtube') return;
    const data = { ...params, send_to: ga4Id };
    gtag('event', name, qa ? { ...data, debug_mode: true, qa_test: true } : data);
  }
  function trackMeta(name, params) {
    if (!pixelId || typeof fbq !== 'function') return;
    fbq('track', name, params);
  }
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || event.source !== 'product-form') return;
    const response = event.cartData;
    const variantId = event.productVariantId;
    const quantity = Number(event.quantityAdded);
    if (!response || !variantId || !Number.isSafeInteger(quantity) || quantity <= 0) return;
    const lines = Array.isArray(response.items) ? response.items : [response];
    const item = lines.find((line) => String(line.variant_id ?? line.id) === String(variantId));
    if (!item) return;
    const cents = Number(item.final_price ?? item.price);
    if (!Number.isFinite(cents) || cents < 0) return;
    const price = cents / 100;
    const value = Math.round(cents * quantity) / 100;
    const params = {
      currency: response.currency || currency(),
      value,
      items: [{ item_id: String(variantId), item_name: item.product_title, item_variant: item.variant_title, quantity, price }],
    };
    trackGa4('add_to_cart', params);
    trackMeta('AddToCart', { content_ids: [String(variantId)], content_type: 'product', value, currency: params.currency });
  });
  document.addEventListener('DOMContentLoaded', () => {
    const product = document.querySelector('main[data-template="product"] product-info');
    if (!product) return;
    const data = product.querySelector('[data-selected-variant]');
    const title = product.querySelector('.product__title');
    if (!data || !title) return;
    let variant;
    try { variant = JSON.parse(data.textContent); } catch { return; }
    const cents = Number(variant.price);
    if (!variant.id || !Number.isFinite(cents) || cents < 0) return;
    const value = cents / 100;
    const params = {
      currency: currency(), value,
      items: [{ item_id: String(variant.id), item_name: title.textContent.trim(), item_variant: variant.public_title || variant.title, quantity: 1, price: value }],
    };
    trackGa4('view_item', params);
    trackMeta('ViewContent', { content_type: 'product', content_ids: [String(variant.id)], value, currency: params.currency });
  }, { once: true });
})();
